// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"aQJeVg9C"};